module.exports = __webpack_public_path__ + "img/mortgage-protection-hands.5c3be04.webp";